import { isEmpty } from '@ember/utils'
import type { NormalizedInterval } from 'date-fns'
import type { StudentsScope } from 'teacher-ui-client/reporting/ui-scope/utils'
import type StudentEventsService from 'teacher-ui-client/services/student-events'
import fillMonths from 'teacher-ui-client/utils/student-events/fill-months'

export interface StorylandsStudentResponse {
  storylands_by_month_events_summary: {
    data: [{ category: 'total_count'; count: number }]
  }
  storylands_by_month_events: {
    month: string
    attempts: number
    average_score: number
  }[]
}

export interface StorylandsStudentData {
  summary: {
    total_count: number
  }
  months: {
    month: string
    attempts: Nullable<number>
    average_score: Nullable<number>
  }[]
}

export async function storylandsStudent(
  this: StudentEventsService,
  product: LegacyProductRe,
  statsScope: StudentsScope,
  period: NormalizedInterval,
): Promise<Nullable<StorylandsStudentData>> {
  if (isEmpty(statsScope.ids)) return null

  const url = this.buildUrl('storylands_by_month_events', product, statsScope)
  const query = this.buildQuery(statsScope, period)

  const data = await this.fetchData<StorylandsStudentResponse>(url, query)
  if (!data) return null

  const { storylands_by_month_events_summary: summaryData, storylands_by_month_events: monthData } = data
  if (monthData.length === 0) return null

  return {
    summary: {
      total_count: summaryData.data.find((summary) => summary.category === 'total_count')!.count,
    },
    months: fillMonths(monthData, period, {
      average_score: null,
      attempts: null,
    }),
  }
}
